import PageviewIcon from '@mui/icons-material/Pageview'
import { Tooltip } from '@mui/material'
import { Box } from '@mui/system'
import { createColumnHelper } from '@tanstack/react-table'
import { TaxiVehicleType } from 'api/models/Common/JyrneyEnums'
import { TaxiRate } from 'api/vehicle/taxisRatesAPI.types'

const getClientTaxiRatesColumns = () => {
  const columnHelper = createColumnHelper<TaxiRate>()

  const clientTaxiRatesTableColumns = (options?: {
    onViewRate?: (id: number) => void
  }) => [
    columnHelper.accessor(
      (row) => {
        return `${row.areaGroupName}`.toUpperCase()
      },
      {
        id: 'Area Name',
        enableSorting: true,
      },
    ),
    columnHelper.accessor(
      (row) => {
        console.log(row)
        return TaxiVehicleType[
          row.vehicleTypeName as unknown as keyof typeof TaxiVehicleType
        ]
      },
      {
        id: 'Vehicle Type',
      },
    ),
    columnHelper.display({
      id: 'View',
      cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
          title="View Rate"
          onClick={() => {
            if (row.original.id !== undefined) {
              if (options?.onViewRate) {
                options.onViewRate(row.original.id)
              }
            } else {
              console.error('ID is undefined')
            }
          }}
        >
          <Tooltip title="View Mileage Rate">
            <PageviewIcon />
          </Tooltip>
        </Box>
      ),
    }),
  ]

  return { clientTaxiRatesTableColumns }
}

export default getClientTaxiRatesColumns
